export const styles = {
  wrapper: {
    width: "100%",
    maxWidth: "519px",
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    display: "flex",
    alignItems: "center",
    flexDirection: "column",
    bgcolor: "#fff",
    padding: "56px 64.5px 40px 64.5px",
    boxShadow: "0px 0px 25px 0px rgba(22, 22, 22, 0.05)",
    borderRadius: "1.5rem",
  },

  continueButton: {
    height: "50px",
    marginTop: "42px",
    py: 1.5,
    fontSize: "1rem",
    textTransform: "none",
    borderRadius: "1.75rem",
  },
};
